import Repository from './Repository';

const resource = '/import';

export default {
    import(contact, contactMethod, mailContactMethod, process) {
        return Repository.post(`${resource}`, { contact, contactMethod, mailContactMethod, process });
    },
}